const selectors = {
  buttons: "[data-tech-stack-tag]",
  images: "[data-tech-stack-image]",
};

const elements = {
  buttons: null,
  images: null,
};

const classes = {
  disabled: "opacity-10",
  active: "active",
};

const init = () => {
  elements.buttons = Array.from(document.querySelectorAll(selectors.buttons));

  if (!elements.buttons) return null;

  elements.buttons.forEach((button) =>
    button.addEventListener("click", ({ currentTarget }) => {
      elements.images = Array.from(document.querySelectorAll(selectors.images));

      if (currentTarget.classList.contains(classes.active)) {
        currentTarget.classList.remove(classes.active);
        elements.images.forEach((image) => image.classList.remove(classes.disabled));

        return;
      }

      elements.buttons.forEach((b) => b.classList.remove(classes.active));
      currentTarget.classList.add(classes.active);

      const key = currentTarget.getAttribute("data-tech-stack-tag");
      elements.images.forEach((image) => {
        const imageKey = image.getAttribute("data-tech-stack-image");

        image.classList[imageKey === key ? "remove" : "add"](classes.disabled);
      });
    })
  );
};

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    init();
  },
  {
    once: true,
  }
);
